var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19998 5C5.19998 2.90132 6.90129 1.2 8.99998 1.2C11.0987 1.2 12.8 2.90132 12.8 5C12.8 7.09868 11.0987 8.8 8.99998 8.8C6.90129 8.8 5.19998 7.09868 5.19998 5ZM8.99998 0C6.23855 0 3.99998 2.23858 3.99998 5C3.99998 7.76142 6.23855 10 8.99998 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 8.99998 0ZM4.59998 13C3.37998 13 2.20995 13.4846 1.34729 14.3473C0.484618 15.21 -2.28882e-05 16.38 -2.28882e-05 17.6V19.4C-2.28882e-05 19.7314 0.268606 20 0.599977 20C0.931348 20 1.19998 19.7314 1.19998 19.4V17.6C1.19998 16.6983 1.55819 15.8335 2.19581 15.1958C2.83344 14.5582 3.69824 14.2 4.59998 14.2H13.4C14.302 14.2 15.1683 14.5584 15.8057 15.1958C16.4429 15.833 16.8 16.6977 16.8 17.6V19.4C16.8 19.7314 17.0686 20 17.4 20C17.7314 20 18 19.7314 18 19.4V17.6C18 16.3806 17.5174 15.2104 16.6543 14.3473C15.7914 13.4845 14.6197 13 13.4 13H4.59998Z",
    fill: "#70797B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.55da373f7a4d8b676507011cf6701393.svg";
export { ForwardRef as ReactComponent };